<template>
	<div class="Grouphonor">
		<div class="Grouphonor-top">
			<img
				:src="require('@/assets/images/Grouphonor-top.png')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="Grouphonor-mid">
			<div class="Grouphonor-mid-img">
				<img
					:src="require('@/assets/images/Grouphonor-mid.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Grouphonor-mid-text">
				<span class="mid-text-left">{{ $t('集团荣誉') }}</span>
			</div>
		</div>
		<div class="Grouphonor-title">{{ $t('坚守初心 牢记使命') }}</div>
		<div class="Grouphonor-text">
			{{
				$t(
					'公司于1986年通过了国家IECQ制造厂认可认证，1997年按ISO9000标准建立质量管理体系，同时取得ISO9001质量体系认证证书，2018年取得ISO9001：2015质量体系认证证书。被认定为国家高新技术企业、国家技术创新示范企业、国家企业技术中心、中国制造业单项冠军示范企业。'
				)
			}}
		</div>
		<div class="Grouphonor-timecon">
			<div
				class="Grouphonor-timecon-item"
				v-for="(item, index) in grouphonorlist"
				:key="index"
			>
				<div class="timecon-item-img">
					<div class="item-img-self">
						<img :src="item.iconSJ" class="image-width" alt="" />
					</div>
					<i class="divider"></i>
				</div>
				<div class="timecon-item-textbox">
					<div class="item-textbox-text">
						<div class="textbox-text-inside">
							<div class="textbox-text-time">
								{{ getLangText(item, 'name') }}
							</div>
							<div class="textbox-text-con">
								{{ getLangText(item, 'brief') }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getHonorList } from '@/api';

export default {
	data() {
		return {
			grouphonorlist: []
		};
	},
	created() {
		getHonorList().then(res => {
			let grouphonorlist = res.list;
			this.grouphonorlist = grouphonorlist.reverse();
		});
	}
};
</script>

<style lang="scss">
@use './Grouphonor.scss';
</style>
